import React, { useRef } from "react";
import styled, { css, keyframes } from "styled-components/macro";
import InfiniteScroll from "react-infinite-scroller";
import { ReactComponent as LoadingImg } from "../../../assets/image/loader-2.svg";
const BellAnimation = keyframes`
  0% { transform: rotate(0); }
  1% { transform: rotate(30deg); }
  3% { transform: rotate(-28deg); }
  5% { transform: rotate(34deg); }
  7% { transform: rotate(-32deg); }
  9% { transform: rotate(30deg); }
  11% { transform: rotate(-28deg); }
  13% { transform: rotate(26deg); }
  15% { transform: rotate(-24deg); }
  17% { transform: rotate(22deg); }
  19% { transform: rotate(-20deg); }
  21% { transform: rotate(18deg); }
  23% { transform: rotate(-16deg); }
  25% { transform: rotate(14deg); }
  27% { transform: rotate(-12deg); }
  29% { transform: rotate(10deg); }
  31% { transform: rotate(-8deg); }
  33% { transform: rotate(6deg); }
  35% { transform: rotate(-4deg); }
  37% { transform: rotate(2deg); }
  39% { transform: rotate(-1deg); }
  41% { transform: rotate(1deg); }

  43% { transform: rotate(0); }
  100% { transform: rotate(0); }
`;
const Item = styled.li`
  box-shadow: 0 0 3px #a5a5a5;
  padding: 7px;
  border-radius: 5px;
  background: #fbfbfb;
  margin-bottom: 10px;
  & h4 {
    margin: 0;
    font-size: 17px;
    letter-spacing: 2px;
    text-align: center;
    color: #6a6a6a;
  }
  & .name {
    display: block;
    font-size: 14px;
    text-align: center;
  }
  & .last-update {
    display: block;
    font-size: 14px;
    text-align: center;
  }
  & ul.properties li {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
  }
  & ul.properties li i {
    font-size: 18px;
    line-height: inherit;
    color: var(--color1);
  }
  & ul.properties li span:first-child i {
    float: right;
    margin-left: 5px;
  }
  & ul.properties li span:last-child i {
    float: left;
    margin-right: 5px;
  }
  & ul.properties li.Reminder-date {
    justify-content: center;
  }
  & ul.properties li.Reminder-date span {
    font-weight: 600;
    font-size: 14px;
  }
  & ul.properties li.Reminder-date i {
    color: var(--failed);
    -webkit-animation: ${BellAnimation} 4s 0.7s ease-in-out infinite;
    -webkit-transform-origin: 50% 4px;
    -moz-animation: ${BellAnimation} 4s 0.7s ease-in-out infinite;
    -moz-transform-origin: 50% 4px;
    animation: ${BellAnimation} 4s 0.7s ease-in-out infinite;
    transform-origin: 50% 4px;
  }
`;

const Wrapper = styled.ul`
  height: calc(100% - 70px);
  overflow-x: hidden;
  overflow-y: auto;
  padding: 10px 15px;
  & ${Item} {
    border-left: 2px solid ${({ color }) => color};
  }
`;
export default function HistoryList({
  config,
  color,
  click,
  fetchMore,
  hasMore,
  hasReminder
}) {
  const wrapperRef = useRef();
  if (!config.length && !hasMore) {
    return (
      <h2
        css={css`
          text-align: center;
          color: #636363;
        `}
      >
        موردی برای نمایش وجود ندارد
      </h2>
    );
  }
  return (
    <Wrapper color={color} as="div">
      <InfiniteScroll
        element="ul"
        loadMore={fetchMore}
        hasMore={hasMore}
        loader={
          <Item
            css={css`
              height: 70px;
            `}
          >
            <LoadingImg></LoadingImg>
          </Item>
        }
        useWindow={false}
      >
        {config.map(item => (
          <Item onClick={() => click(item)}>
            <>
              <h4>{item.CustomerMainMobile}</h4>
              {item.CustomerName ? (
                <span className="name">{item.CustomerName}</span>
              ) : null}
              <ul className="properties">
                <li>
                  <span>
                    <i className="md md-pin"></i>
                    {item.CityName}
                  </span>
                  <span>
                    <i className="md md-time-restore"></i>
                    {item.LastUpdate}
                  </span>
                </li>
                {hasReminder ? (
                  <li className="Reminder-date">
                    <span>
                      <i className="md md-notifications"></i>
                      {item.Reminder}
                    </span>
                  </li>
                ) : null}
              </ul>
            </>
          </Item>
        ))}
      </InfiniteScroll>
    </Wrapper>
  );
}
